import { LANGUAGE_OPTIONS, MEDIA_TYPE_OPTIONS } from '@/modules/shraddha-shorts/constants'

export const getCardContentFormFields = (isEditing: boolean) => [
  [
    {
      name: 'language_code',
      label: 'Language Code',
      type: 'select',
      options: LANGUAGE_OPTIONS,
      required: true,
      message: 'Please enter language code',
      disabled: isEditing,
      span: 24,
      placeholder: 'Select language',
    },
  ],
  [
    {
      name: 'title',
      label: 'Title',
      type: 'input',
      required: true,
      message: 'Please enter title',
      span: 24,
    },
  ],
  [
    {
      name: 'display_name',
      label: 'Display Name',
      type: 'input',
      span: 24,
    },
  ],
  [
    {
      name: 'description',
      label: 'Description',
      type: 'textarea',
      required: true,
      message: 'Please enter description',
      span: 24,
      rows: 3,
    },
  ],
  [
    {
      name: 'media_type',
      label: 'Media Type',
      type: 'select',
      options: MEDIA_TYPE_OPTIONS,
      required: true,
      message: 'Please select media type',
      span: 12,
    },
    {
      name: 'media',
      label: 'Media',
      type: 'upload',
      required: true,
      message: 'Please upload media',
      span: 12,
      valuePropName: 'fileList',
      getValueFromEvent: (e: any) => {
        if (Array.isArray(e)) return e
        return e?.fileList
      },
    },
  ],
  [
    { name: ['cta', 'text'], label: 'CTA Text', type: 'input', span: 12 },
    {
      name: ['cta', 'deeplink'],
      label: 'CTA Deeplink',
      type: 'input',
      span: 12,
    },
  ],
  [
    {
      name: 'active',
      label: 'Active',
      type: 'switch',
      span: 12,
      valuePropName: 'checked',
    },
  ],
]
